import { IconButton } from "@ac-expo/ui-components";
import Link from "next/link";
import { useState } from "react";

export function DownloadAppsBanner() {
  const [isRender, setIsRender] = useState(true);

  if (!isRender) return null;

  return (
    <div className="relative flex flex-wrap justify-center gap-3 bg-primary-500 py-2 xl:py-3">
      <div className="flex flex-wrap items-center gap-2 xl:gap-4">
        <div className="flex grow justify-center">
          <img
            className="size-12"
            src="/images/logos/connect_events_logomark_white.png"
            alt="Logo de l'application Connect'Events"
          />
        </div>
        <p className="text-justify text-base font-semibold text-white max-xl:mx-2 md:text-lg">
          <strong className="font-bold">Téléchargez dès maintenant</strong>{" "}
          notre application et profitez d’un contenu exclusif où que vous soyez.
        </p>
      </div>
      <div className="flex items-center gap-2.5">
        <Link
          className="shrink-0"
          href="https://play.google.com/store/apps/details?id=com.acexpoorganization.connectevents"
        >
          <img
            className="h-10"
            src="/images/google_play_badge.png"
            alt="Télécharger sur le Play Store"
          />
        </Link>
        <Link
          className="shrink-0"
          href="https://apps.apple.com/us/app/connectevents/id6503937582"
        >
          <img
            className="h-10"
            src="/images/svg/app_store_badge.svg"
            alt="Télécharger sur l'App Store"
          />
        </Link>
        <IconButton
          className="max-md:absolute max-md:right-5 max-md:top-5"
          svgType="x"
          svgProps={{ size: 14, className: "text-white" }}
          onClick={() => setIsRender(false)}
        />
      </div>
    </div>
  );
}

export default DownloadAppsBanner;
